import React, { useState, useContext } from "react";

import { TranslationsContext } from "./context/translationsContext";
import SubmitButton from "./submitButton";
import RatingStars from "./ratingStars";
import apiSubmitHandler from "./utils/apiSubmitHandler";

function CreateComment(props) {
  const [submitting, setSubmitting] = useState(false);
  const [response, setResponse] = useState("");
  const [rating, setRating] = useState(0);

  const translations = useContext(TranslationsContext);

    function submitComment(event) {
    event.preventDefault();
  
    const authorName = event.target.author_name?.value || "";
    const authorEmail = event.target.author_email?.value || "";
    const commentContent = event.target.comment_content?.value || "";
    const postId = props.pageId;
    const parentId = props.parentId || 0;
  
    setSubmitting(true);
  
    // derive host base from restUrl (restUrl is like https://site/wp-json/wp/v2/comments)
    const hostBase = (props.restUrl || "").replace(/\/wp-json\/.*$/, "") || "";
  
    // If there's a rating, post using the legacy comment POST endpoint that WPRM hooks into
    if (rating > 0 && hostBase) {
      const form = new URLSearchParams();
      form.append("author", authorName);
      form.append("email", authorEmail);
      form.append("comment", commentContent);
      form.append("comment_post_ID", String(postId));
      form.append("comment_parent", String(parentId));
      form.append("wprm-comment-rating", String(rating));
      form.append("submit", "Post Comment");
  
      fetch(`${hostBase}/wp-comments-post.php`, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: form.toString(),
      })
        .then(res => {
          // wp-comments-post.php typically redirects (302) to the post page.
          // The comment will be saved and WPRM will handle the rating server-side.
          console.log("wp-comments-post.php status:", res.status);
          // After posting, fetch comments through REST to refresh UI:
          return fetch(props.restUrl, { method: "GET", mode: "cors" });
        })
        .then(res => (res.ok ? res.json() : []))
        .then(resultData => {
          // You probably want to notify parent to reload comments; simple local feedback for now:
          setResponse("Comment submitted (awaiting review).");
          setSubmitting(false);
          setRating(0);
          // Optionally: trigger parent refresh using props.onCommentPosted(resultData) if you add such prop
        })
        .catch(err => {
          console.error("Error posting comment via wp-comments-post.php:", err);
          setSubmitting(false);
          setResponse("Error submitting comment. Please try again.");
        });
  
      return;
    }
  
    // Fallback: submit via REST (existing flow)
    const reqHeaders = { "Content-Type": "application/json" };
    if (props.user) reqHeaders.Authorization = `Bearer ${props.user.jwt}`;
  
    const payload = {
      author_name: authorName,
      author_email: authorEmail,
      content: commentContent,
      post: postId,
      parent: parentId,
    };
  
    // include rating as well for REST attempts (some setups might pick it up)
    if (rating > 0) payload.wprm_comment_rating = String(rating);
  
    fetch(props.restUrl, {
      method: "POST",
      mode: "cors",
      headers: reqHeaders,
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(result => {
        setSubmitting(false);
        setResponse(apiSubmitHandler(result));
        if (!result.code && !result.error) {
          setRating(0);
          event.target.reset();
        }
      })
      .catch(error => {
        console.error("Error:", error);
        setSubmitting(false);
        setResponse("Error submitting comment. Please try again.");
      });
  }

  function cancelResponse(e) {
    e.preventDefault();
    if (props.setParentId) props.setParentId(0);
  }

  if (props.allowComments) {
    const displayStarRating = !!props.showStarRating; // Set to true to display star rating input
    return (
      <div className="comment-respond">
        <h3 className="reply-title">
          {translations.leaveCommentHeading}
          {props.parentId ? (
            <small>
              <button onClick={cancelResponse} href={`#comment-${props.parentId}`}>
                {translations.cancelLinkLabel}
              </button>
            </small>
          ) : null}
        </h3>
        <form onSubmit={submitComment}>
          {props.user ? (
            <>
              <p>
                {translations.loggedInUserIntro}
                {props.user.name}
              </p>
              <input type="hidden" name="author_name" value={props.user.name} />
              <input type="hidden" name="author_email" value={props.user.email} />
            </>
          ) : (
            <>
              <fieldset>
                <p className="comment-input-name">
                  <label>
                    {translations.nameInputLabel}
                    <input
                      title="Name to be displayed on comment, 30 symbols max"
                      maxLength={30}
                      name="author_name"
                      required
                    />
                  </label>
                </p>
                <p className="comment-input-email">
                  <label>
                    {translations.emailInputLabel}
                    <input
                      type="email"
                      title="A valid email address of the author"
                      name="author_email"
                      required
                    />
                  </label>
                </p>
              </fieldset>
            </>
          )}

          {/* Rating stars input */}
          {displayStarRating &&
            <div style={{ marginBottom: "1rem" }}>
            <RatingStars
              ratingValue={rating}
              isReadOnly={false}
              onChange={setRating}
              label="Rate this recipe:"
            />
          </div>}

          <p className="comment-input-content">
            <label>
              {translations.commentInputLabel}
              <textarea
                placeholder={translations.commentInputPlaceholder}
                maxLength={2000}
                name="comment_content"
                rows={4}
                required
              ></textarea>
            </label>
          </p>

          <SubmitButton isSubmitting={submitting} />
          {response && <p className="comment-submit-info">{response}</p>}
        </form>
      </div>
    );
  } else {
    return (
      <div>
        <p>{translations.commentsClosedNotice}</p>
      </div>
    );
  }
}

export default CreateComment;